export const getLayoutClass = (layout = '1') => {
  return `vitrine-template3--layout-${layout}`;
};
